import type React from 'react';
import type { SelectableItem } from '~/models/CampaignModel';
import { ProductType } from '../../../../../models/product/ProductType';
import { useBasket } from '../../useBasket';
import BasketList from '../basket-list/BasketList';
import BasketListItem from '../basket-list/basket-list-item/BasketListItem';
import BasketProduct from '../basket-list/basket-list-item/BasketProduct';

interface ReduxProps {
  onlyActivelyChosenProducts?: boolean;
}
export interface SimpleSummaryProps {
  selectedProducts: SelectableItem[];
  hideShipping: boolean;
}

export const SimpleSummary: React.FC<SimpleSummaryProps & ReduxProps> = ({
  onlyActivelyChosenProducts = false,
  selectedProducts,
  hideShipping,
}) => {
  const flexipakkenChoice = useBasket((s) => s.flexipakkenChoice);
  const hasEquipment =
    selectedProducts.filter(
      (product) =>
        product.productType === ProductType.Equipment ||
        product.productType === ProductType.Receiver ||
        product.productType === ProductType.Installation,
    ).length > 0;

  const hasPremiums = selectedProducts.filter((product) => product.productType === ProductType.Premium).length > 0;
  const hasInternet = selectedProducts.filter((product) => product.productType === ProductType.Internet).length > 0;

  const getProductsFromCategory = (category: ProductType, hideIfFree = false) =>
    selectedProducts
      .filter((x) => x.productType === category)
      .map((x) => <BasketProduct key={x.id} product={x} hideIfFree={hideIfFree} />);

  return (
    <>
      <BasketList title="Abonnement">
        {getProductsFromCategory(ProductType.Subscription)}
        {flexipakkenChoice && (
          <BasketListItem
            id={`flexipakken-${flexipakkenChoice.kind === 'streaming' ? flexipakkenChoice.channelId : 'tv-channels'}`}
            name={flexipakkenChoice.name}
            priceLabel="Inkludert"
          />
        )}
      </BasketList>
      {hasInternet && <BasketList title="Internett">{getProductsFromCategory(ProductType.Internet)}</BasketList>}

      {hasPremiums && <BasketList title="Tilleggspakker">{getProductsFromCategory(ProductType.Premium)}</BasketList>}

      {hasEquipment && (
        <BasketList title="Utstyr">
          {getProductsFromCategory(ProductType.Receiver)}
          {getProductsFromCategory(ProductType.Equipment)}
          {getProductsFromCategory(ProductType.Installation, onlyActivelyChosenProducts)}

          {!onlyActivelyChosenProducts && getProductsFromCategory(ProductType.Shipping, hideShipping)}
        </BasketList>
      )}
    </>
  );
};
